import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_LOCATION_TYPES);

const _pk_name = "id";

const state = {
  data: [],
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const getters = {
  getLocationTypes: (state)=>{
    if(state.data){
      return state.data
    }else{
      this.fetchAll()
    }
  }
}

const mutations = {
  set: (state, payload) => {
    state.data = payload;
  },

  addEntity: (state, payload) => {
    state.data.push(payload);
  },

  updateEntityById: (state, payload) => {
    //console.log(payload)
    for(let i=0; i<state.data.length; i++) {
      if(state.data[i][_pk_name] === payload.id) {
        //console.log(state.data[i][_pk_name])
        state.data.splice(i, 1, payload);
      }
    }
  },

  removeEntityById: (state, payload) => {
    for (let i=0; i<state.data.length; i++){
      if (state.data[i][_pk_name] == payload){
        state.data.splice(i, 1);
      }
    }
  },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {
  async fetchAll({commit}) {
      //console.log("[state/onboard/location_types/fetchAll] Calling API...");
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`);
      commit("setFetching", false);
      //console.log("[state/onboard/location_types/fetchAll] res: ", res);
      if(res.status == 200) {
        commit("set", res.data);
      }
      return res;
    }catch(err) {
      //console.log(err)
    }
  },

  async create({commit}, payload) {
      //console.log("[state/onboard/business_units/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/onboard/business_units/create] res: ", res);
      if(res.status == 200) {
        commit("addEntity", res.data);
      }
      return res;
    }catch (err) {
      //console.log(err)
    }
  },

  async update({commit}, payload) {
      //console.log("[state/onboard/business_units/update] Updating... Display payload", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(`/${payload.id}`, payload);
      commit("setSaving", false);
      //console.log("[state/onboard/business_units/update] res: ", res);
      if(res.status == 200) {
        commit("updateEntityById", res.data);
      }
      return res;
    }catch(err) {
     //console.log(err)
    }
  },

  async delete({commit}, payload) {
    //console.log("[state/onboard/business_units/delete] Payload:", payload);
    //console.log("[state/onboard/business_units/delete] Payload:", `/${payload.id}`);
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200){
        commit("removeEntityById", payload.id);
      }
    }catch(err) {
      //console.log(err)
    }
  }
}

export default {
  namespaced: true,
  state, mutations, actions, getters
}
